import React, { lazy, useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fabric } from 'fabric'
import { connect } from 'react-redux'
import { Prompt } from 'react-router-dom'
import Loading from '@/Common/loading/loading'
import CanvasTimelineEditor from '@/MakeVideo/YoutubeShorts/Component/YoutubeUrlToShorts/Components/CanvasTimelineEditor'
import { withYoutubeUrlToShortsContext, withYoutubeUrlToShortsProvider } from '@/MakeVideo/YoutubeShorts/Component/YoutubeUrlToShorts/contexts/YoutubeUrlToShortsContext';
import i18n from '../i18n'
import './ShortsCustomizing.scss';
import { ROUTE_PATH } from '@/utils/Global';
const PaletteMenu = lazy(() => import('@/MakeVideo/PaletteMenu/PaletteMenu'))
const PaletteItem = lazy(() => import('@/MakeVideo/PaletteMenu/PaletteItem/PaletteItem'))

const SCRIPT_TAB_ITEMS = [
    {
        key: 'show',
        label: '스크립트 보기',
    },
    {
        key: 'edit',
        label: '스크립트 편집하기',
    }
]
const LAYOUT_TYPE = [
    {
        id: 'Layout01',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-01.jpg'
    },
    {
        id: 'Layout02',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-02.jpg'
    },
    {
        id: 'Layout03',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-03.jpg'
    },
    {
        id: 'Layout04',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-04.jpg'
    },
    {
        id: 'Layout05',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-05.jpg'
    },
    {
        id: 'Layout06',
        src: 'https://front.videomonster.com/images-7cuytg20/common/ai/layout-06.jpg'
    }
];

const TEXT_OPTIONS = {
    FONT: 'font',
    HORIZONTAL_ALIGN: 'horizontal-align',
    VERTICAL_ALIGN: 'vertical-align',
    LINE_HEIGHT: 'line-height',
    COLOR: 'color',
}

const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const ShortsCustomizing = (props) => {
    const {
        history,
        // currentUser,
        value,
        // paymentMode,

        context: {
            lastUpdated,
            metadataJson,
            timelineData,

            LEFT_TAB_ITEMS,

            leftTab,
            layoutType,
            fonts,

            currentActiveObject,
            currentSentence,

            setLeftTab,
            handleUpdateLayout,
            updateCurrentSentence,

            updateVideoCurrentTime,
            updateSentence,

            updateTextOptions
        }
    } = props

    const currentUser = useSelector(state => state.userStore.user)
    // const { duration } = metadataJson;
    const { topic, sentences } = timelineData;
    const enabledSentences = sentences.filter(sentence => sentence.enabled)
    enabledSentences.sort((a, b) => a.start - b.start)

    const [scriptTab, setScriptTab] = useState(SCRIPT_TAB_ITEMS[0]);
    const [currentTextOption, setCurrentTextOption] = useState(null);

    const scriptTabDivRef = useRef(null);

    useEffect(() => {
        // if (scriptTabDivRef.current) {
        //     if (scriptTab.key === 'edit') {
        //         for (let i = 0; i < enabledSentences.length; i++) {
        //             const sentence = enabledSentences[i]
        //             const sentenceDiv = document.getElementById(`sentence-${sentence.id}`);
        //             if (sentenceDiv) {
        //                 sentenceDiv.scrollIntoView({ block: 'center' });
        //                 break
        //             }
        //         }
        //     }
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scriptTab, scriptTabDivRef.current])

    useEffect(() => {
        if (currentActiveObject instanceof fabric.IText) {
            setCurrentTextOption(null)
        }
    }, [currentActiveObject])

    const handleClickScriptTime = time => {
        updateVideoCurrentTime(time)
    }

    const handleClickScriptText = sentence => {
        updateVideoCurrentTime(sentence.start)
        updateCurrentSentence(sentence)
    }

    const handleClickTextOption = option => {
        if (currentTextOption === option) {
            setCurrentTextOption(null)
        }
        else {
            setCurrentTextOption(option)
        }
    }

    const handleExit = () => {
        if (currentUser) {
            history.push(ROUTE_PATH.MY_VIDEOS_SHORTS)
        }
        else {
            history.push(ROUTE_PATH.HOME)
        }
    }

    const renderSentenceOptions = sentence => {
        if (!currentSentence || currentSentence.id !== sentence.id) return null;
        return (
            <div className='script-option'>
                {
                    sentence.enabled
                        ?
                        (
                            <div className='script-option-item' onClick={() => updateSentence({ ...sentence, enabled: false })}>
                                <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/script-delete.svg" alt="" />
                            </div>
                        )
                        :
                        (
                            <div className='script-option-item' onClick={() => updateSentence({ ...sentence, enabled: true })}>
                                <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/script-add.svg" alt="" />
                            </div>
                        )
                }
            </div>
        )
    }

    const renderLeftTab = () => {
        if (leftTab === 'script') {
            const groupedSentenceMap = {}
            if (scriptTab.key === 'show') {
                enabledSentences.forEach(sentence => {
                    if (!groupedSentenceMap[sentence.index]) {
                        groupedSentenceMap[sentence.index] = {
                            start: sentence.start,
                            sentences: []
                        }
                    }
                    groupedSentenceMap[sentence.index].sentences.push(sentence)
                })
            }
            else {
                sentences.forEach(sentence => {
                    if (sentence.index === null || sentence.index === undefined) return;
                    if (!groupedSentenceMap[sentence.index]) {
                        groupedSentenceMap[sentence.index] = {
                            start: sentence.start,
                            sentences: []
                        }
                    }
                    groupedSentenceMap[sentence.index].sentences.push(sentence)
                })
            }
            const groupedSentenceKeys = Object.keys(groupedSentenceMap)
            const groupedSentences = groupedSentenceKeys.map(key => {
                return {
                    start: groupedSentenceMap[key].start,
                    sentences: groupedSentenceMap[key].sentences
                }
            })
            groupedSentences.sort((a, b) => a.start - b.start)

            return (
                <div className="script-tab-container">
                    <div className='tab-buttons-row'>
                        {SCRIPT_TAB_ITEMS.map(item => (
                            <div
                                key={item.key}
                                className={`select-btn ${scriptTab.key === item.key ? 'active' : ''}`}
                                onClick={() => setScriptTab(item)}
                            >
                                {item.label}
                            </div>
                        ))}
                    </div>
                    {
                        scriptTab.key === 'edit' &&
                        <div className='script-edit-description'>
                            스크립트를 편집하면 영상이 실시간 자동으로 편집 됩니다.
                        </div>
                    }
                    <div className={`script-container script-tab-${scriptTab.key}`}>
                        {scriptTab.key === 'show' && (
                            <div className='script-list'>
                                <div className='script-title'>
                                    {`타이틀 ) ${topic.text}`}
                                </div>
                                {
                                    groupedSentences.map(groupedSentence => (
                                        <div className='script-item'>
                                            <div className='script-item-time'>
                                                {formatDuration(groupedSentence.start)}
                                            </div>
                                            <div className='script-item-text'>
                                                {groupedSentence.sentences.map(sentence => sentence.text).join(' ')}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )}
                        {scriptTab.key === 'edit' && (
                            <div
                                className='script-list'
                                ref={scriptTabDivRef}
                            >
                                <div className='script-title'>
                                    {`타이틀 ) ${topic.text}`}
                                </div>
                                {groupedSentences.map(groupedSentence => (
                                    <div className='script-edit-item'>
                                        <div
                                            className='script-edit-item-time'
                                            onClick={() => handleClickScriptTime(groupedSentence.start)}
                                        >
                                            {formatDuration(groupedSentence.start)}
                                        </div>
                                        <div className='script-edit-item-texts'>
                                            {groupedSentence.sentences.map(sentence => (
                                                <div
                                                    id={`sentence-${sentence.id}`}
                                                    className={'script-edit-item-text'}
                                                    onClick={() => handleClickScriptText(sentence)}
                                                >
                                                    <div
                                                        className={
                                                            `script-edit-item-text-content ${sentence.enabled ? '' : 'disabled'} ${currentSentence && sentence.id === currentSentence.id ? 'selected' : ''}`
                                                        }
                                                    >
                                                        {sentence.text}
                                                        {renderSentenceOptions(sentence)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        if (leftTab === 'layout') {
            return (
                <div className="layout-tab-container">
                    {LAYOUT_TYPE.map(layout => (
                        <div key={layout.id} className={`layout-item ${layoutType === layout.id ? 'selected' : ''}`} onClick={() => handleUpdateLayout(layout.id)}>
                            <img src={layout.src} alt="" />
                        </div>
                    ))}
                </div>
            )
        }
        if (leftTab === 'font') {
            if (currentActiveObject instanceof fabric.IText) {
                return (
                    <div className="text-option-tab-container">
                        <div className="font-list-container" onClick={() => handleClickTextOption(TEXT_OPTIONS.FONT)}>
                            <span>{currentActiveObject.fontFamily || "폰트를 선택해주세요"}</span>
                            {
                                currentTextOption === TEXT_OPTIONS.FONT
                                    ?
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-font-arrow-up.svg" alt="" />
                                    :
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-font-arrow-down.svg" alt="" />
                            }
                            {
                                currentTextOption === TEXT_OPTIONS.FONT && (
                                    <div className="font-list">
                                        {
                                            fonts.map(font => (
                                                <div
                                                    key={font.postscriptName}
                                                    className={`font-item ${currentActiveObject.fontFamily === font.postscriptName ? 'active' : ''}`}
                                                    onClick={() => updateTextOptions({ fontFamily: font.postscriptName })}
                                                >
                                                    <img src={font.blackImageURL} alt="" />
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                            }
                        </div>
                        <div className="text-style-options-container">
                            <div className="text-size-option">
                                <div
                                    className="text-size-down-btn"
                                    onClick={() => updateTextOptions({ fontSize: Number(currentActiveObject.fontSize - 1) })}
                                >
                                    -
                                </div>
                                <div className="text-size-value">{currentActiveObject.fontSize || 0}</div>
                                <div
                                    className="text-size-up-btn"
                                    onClick={() => updateTextOptions({ fontSize: Number(currentActiveObject.fontSize + 1) })}
                                >
                                    +
                                </div>
                            </div>
                            <div className="text-style-option">
                                <div
                                    className={`text-style-btn ${currentActiveObject.fontWeight === 'bold' ? 'active' : ''}`}
                                    onClick={() => updateTextOptions({ fontWeight: currentActiveObject.fontWeight === 'bold' ? 'normal' : 'bold' })}
                                >
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-bold.svg" alt="" />
                                </div>
                                <div
                                    className={`text-style-btn ${currentActiveObject.fontStyle === 'italic' ? 'active' : ''}`}
                                    onClick={() => updateTextOptions({ fontStyle: currentActiveObject.fontStyle === 'italic' ? 'normal' : 'italic' })}
                                >
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-italic.svg" alt="" />
                                </div>
                                <div
                                    className={`text-style-btn ${currentActiveObject.underline ? 'active' : ''}`}
                                    onClick={() => updateTextOptions({ underline: currentActiveObject.underline ? false : true })}
                                >
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-underline.svg" alt="" />
                                </div>
                                <div
                                    className={`text-style-btn ${currentActiveObject.linethrough ? 'active' : ''}`}
                                    onClick={() => updateTextOptions({ linethrough: currentActiveObject.linethrough ? false : true })}
                                >
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-linethrough.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="text-align-options-container">
                            <div
                                className={`text-align-option-btn ${currentTextOption === TEXT_OPTIONS.HORIZONTAL_ALIGN ? 'active' : ''}`}
                                onClick={() => handleClickTextOption(TEXT_OPTIONS.HORIZONTAL_ALIGN)}
                            >
                                {
                                    currentActiveObject.textAlign === 'left' &&
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-left.svg" alt="" />
                                }
                                {
                                    currentActiveObject.textAlign === 'center' &&
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-center.svg" alt="" />
                                }
                                {
                                    currentActiveObject.textAlign === 'right' &&
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-right.svg" alt="" />
                                }
                            </div>
                            <div
                                className={`text-align-option-btn disabled`}
                                onClick={() => handleClickTextOption(TEXT_OPTIONS.VERTICAL_ALIGN)}
                            >
                                <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-vertical-align-center.svg" alt="" />
                            </div>
                            <div
                                className={`text-align-option-btn ${currentTextOption === TEXT_OPTIONS.LINE_HEIGHT ? 'active' : ''}`}
                                onClick={() => handleClickTextOption(TEXT_OPTIONS.LINE_HEIGHT)}
                            >
                                <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-lineheight.svg" alt="" />
                            </div>
                            <div className='divider' />
                            <label for="text-color-input" className='text-color-label' />
                            <div className="text-color-option-btn">
                                <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-color.svg" alt="" />
                                <div className="text-color"
                                    style={{
                                        backgroundColor: currentActiveObject.fill || '#000000'
                                    }}
                                />
                                <input
                                    id="text-color-input"
                                    className="input-color"
                                    type="color"
                                    value={currentActiveObject.fill || '#000000'}
                                    onChange={(e) => updateTextOptions({ fill: e.target.value })}
                                />
                            </div>
                            {
                                currentTextOption === TEXT_OPTIONS.HORIZONTAL_ALIGN &&
                                <div className="text-horizontal-align-btns-overlay">
                                    <div
                                        className={`text-horizontal-align-btn ${currentActiveObject.textAlign === 'left' ? 'selected' : ''}`}
                                        onClick={() => {
                                            updateTextOptions({ textAlign: 'left' })
                                            handleClickTextOption(null)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-left.svg" alt="" />
                                    </div>
                                    <div
                                        className={`text-horizontal-align-btn ${currentActiveObject.textAlign === 'center' ? 'selected' : ''}`}
                                        onClick={() => {
                                            updateTextOptions({ textAlign: 'center' })
                                            handleClickTextOption(null)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-center.svg" alt="" />
                                    </div>
                                    <div
                                        className={`text-horizontal-align-btn ${currentActiveObject.textAlign === 'right' ? 'selected' : ''}`}
                                        onClick={() => {
                                            updateTextOptions({ textAlign: 'right' })
                                            handleClickTextOption(null)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-align-right.svg" alt="" />
                                    </div>
                                </div>
                            }
                            {/* {
                                <div className="text-vertical-align-btns-overlay">
                                    <div
                                        className={`text-vertical-align-btn ${currentActiveObject.verticalAlign === 'top' ? 'selected' : ''}`}
                                        onClick={() => {
                                            setIsOpenTextVerticalAlignOptions(false)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-vertical-align-top.svg" alt="" />
                                    </div>
                                    <div
                                        className={`text-vertical-align-btn ${currentActiveObject.verticalAlign === 'center' ? 'selected' : ''}`}
                                        onClick={() => {
                                            setIsOpenTextVerticalAlignOptions(false)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-vertical-align-center.svg" alt="" />
                                    </div>
                                    <div
                                        className={`text-vertical-align-btn ${currentActiveObject.verticalAlign === 'bottom' ? 'selected' : ''}`}
                                        onClick={() => {
                                            setIsOpenTextVerticalAlignOptions(false)
                                        }}
                                    >
                                        <img src="https://front.videomonster.com/images-7cuytg20/common/ai/customize/text-vertical-align-bottom.svg" alt="" />
                                    </div>
                                </div>
                            } */}
                            {
                                currentTextOption === TEXT_OPTIONS.LINE_HEIGHT &&
                                <div className='text-lineheight-options-overlay'>
                                    <div className='text-lineheight-option'>
                                        <div className='text-lineheight-option-label'>
                                            <span>행간</span>
                                            <input
                                                type="number"
                                                min="0.1"
                                                max="3.0"
                                                value={currentActiveObject.lineHeight}
                                                onChange={(e) => updateTextOptions({ lineHeight: Number(e.target.value) })}
                                            />
                                        </div>
                                        <div className='text-lineheight-option-progressbar'>
                                            <div className="input-range-container">
                                                <div
                                                    className="input-range-track"
                                                    style={{
                                                        left: `0%`,
                                                        right: `${(100 - (currentActiveObject.lineHeight / 3) * 100)}%`
                                                    }}
                                                />
                                                <input
                                                    type="range"
                                                    className="input-range"
                                                    min="0.1"
                                                    max="3.0"
                                                    step="0.1"
                                                    value={currentActiveObject.lineHeight}
                                                    onChange={(e) => updateTextOptions({ lineHeight: Number(e.target.value) })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="text-toggle-option-container">
                            <div className="text-toggle-option-title">
                                <span>외곽선</span>
                                <div
                                    className={`toggle-btn ${currentActiveObject.strokeWidth > 0 ? 'active' : ''}`}
                                    onClick={() => updateTextOptions({ strokeWidth: currentActiveObject.strokeWidth > 0 ? 0 : 1 })}
                                >
                                    <div className="toggle-btn-inner-circle" />
                                </div>
                            </div>
                            {
                                currentActiveObject.strokeWidth > 0 &&
                                <div className="text-toggle-options">
                                    <div className="text-toggle-option">
                                        <div className="title">색상</div>
                                        <input
                                            className="input-color"
                                            type="color"
                                            value={currentActiveObject.stroke || '#000000'}
                                            onChange={(e) => updateTextOptions({ stroke: e.target.value })}
                                        />
                                    </div>
                                    <div className="text-toggle-option">
                                        <div className="title">두께</div>
                                        <input
                                            className="input-number"
                                            type="number"
                                            min="1"
                                            max="10"
                                            step="1"
                                            value={currentActiveObject.strokeWidth}
                                            onChange={(e) => updateTextOptions({ strokeWidth: Number(e.target.value) })}
                                        />
                                    </div>
                                    <div className='text-toggle-option-progressbar'>
                                        <div className="input-range-container">
                                            <div
                                                className="input-range-track"
                                                style={{
                                                    left: `0%`,
                                                    right: `${(100 - ((currentActiveObject.strokeWidth - 1) / 9) * 100)}%`
                                                }}
                                            />
                                            <input
                                                type="range"
                                                className="input-range"
                                                min="1"
                                                max="10"
                                                step="1"
                                                value={currentActiveObject.strokeWidth}
                                                onChange={(e) => updateTextOptions({ strokeWidth: Number(e.target.value) })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            }
        }
        if (leftTab === 'music') {
            return (
                <div className="setting-group">
                </div>
            )
        }

        return null
    }

    return (
        <div className="shorts-customizing-container">
            <Prompt when={lastUpdated !== null} message={i18n.t("makevideo.leave.alert")}></Prompt>
            {
                false ?
                    <Loading />
                    :
                    <>
                        <div className="left-sidebar">
                            <PaletteMenu value={value}>
                                {
                                    LEFT_TAB_ITEMS.map((item, index) => (
                                        <PaletteItem
                                            isAvaliable={true}
                                            value={value}
                                            selected={leftTab === item.key}
                                            src={`/images/common/v2/tab-${item.key}.svg`}
                                            selectedSrc={`/images/common/v2/tab-${item.key}-active.svg`}
                                            itemName={item.label}
                                            onClick={() => { setLeftTab(item.key) }}
                                            showTooltip={false}
                                        />
                                    ))
                                }
                                <div className={'editor-exit-btn'} onClick={handleExit}>
                                    <img src="https://front.videomonster.com/images-7cuytg20/common/v2/exit.svg" alt="" draggable={false}></img>
                                    <p lang={value}>{i18n.t("global.exit")}</p>
                                </div>
                            </PaletteMenu>
                            <div className='left-tab-container'>
                                {renderLeftTab()}
                            </div>
                        </div>
                        <div className="shorts-editor-area scroll">
                            <CanvasTimelineEditor />
                        </div>
                    </>
            }
        </div>
    );
};

const WrappedShortsCustomizing = withYoutubeUrlToShortsProvider(withYoutubeUrlToShortsContext(ShortsCustomizing));

function ShortsCustomizingWithContext(props) {
    const { history } = props

    if (!history || !history.location || !history.location.state) {
        history.push(ROUTE_PATH.MY_VIDEOS_SHORTS)
        alert("오류가 발생했습니다. 다시 시도해주세요.")
        return null
    }

    const {
        index,
        shortsId,
        metadataJson,
        videoUrl,
        audioUrl,
        previewImageUrl,
        initData
    } = history.location.state;

    return (
        <WrappedShortsCustomizing
            {...props}
            index={index}
            shortsId={shortsId}
            isEditor={true}
            initData={{
                metadataJson,
                videoUrl,
                audioUrl,
                previewImageUrl,
                initData
            }}
        />
    )
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
    value: state.langStore.lang,
    paymentMode: state.paymentModeStore.paymentMode,
})

export default connect(
    mapStateToProps,
    null
)(ShortsCustomizingWithContext)
